import { render, staticRenderFns } from "./BodyCellDefault.vue?vue&type=template&id=4ab27af6&scoped=true&"
import script from "./BodyCellDefault.vue?vue&type=script&lang=js&"
export * from "./BodyCellDefault.vue?vue&type=script&lang=js&"
import style0 from "./BodyCellDefault.vue?vue&type=style&index=0&id=4ab27af6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab27af6",
  null
  
)

export default component.exports